import { IEnvironmentConfig } from '@app/core/interfaces/extension-environment';

export const environment: IEnvironmentConfig = {
    production: true,
    extension: 'outlook',
    API_URL: 'https://api.calendarhero.com/'
};
